export default "__VITE_ASSET__Br8Hb5gk__"